import React, { useState } from "react";
import data from "./RecCardData";
import "./RecCard.css";
import EstimateCard from "./EstimateCard/EstimateCard";
import Footer from "../Blocktitle/footer/Footer";
import { appfeature } from "../Config/Helper";
import imageData from "./ImageData";

const RecCard = () => {
  const [appdataState, setAppDataState] = useState();

  const [appSelected, setAppSelected] = useState({
    0: false,
    1: false,
    2: false,
  });
  const [uiSelected, setUiSelected] = useState({
    0: false,
    1: false,
    2: false,
  });
  const [otherSelected, setOtherSelected] = useState(data); // Initialize with data

  const handleCardSelect = (name, index, cardindex) => {
    appfeature(name, index);
    const appdata = JSON.parse(localStorage.getItem("appFeatures"));
    setAppDataState(appdata);

    if (index === 0) {
      const updatedAppSelected = { 0: false, 1: false, 2: false };
      updatedAppSelected[cardindex] = !appSelected[cardindex];
      setAppSelected(updatedAppSelected);
    } else if (index === 1) {
      const updatedUiSelected = { 0: false, 1: false, 2: false };
      updatedUiSelected[cardindex] = !uiSelected[cardindex];
      setUiSelected(updatedUiSelected);
    } else {
      const updatedOtherSelected = { ...otherSelected };
      updatedOtherSelected[index][cardindex] =
        !updatedOtherSelected[index][cardindex];
      setOtherSelected(updatedOtherSelected);
    }
  };

  return (
    <>
      <div className="section">
        <div className="cardinfo">
          {data.map((data, index) => {
            return (
              <div className="title">
                {/* <div className="card_Index">{index + 3}</div> */}
                <div className="heading">
                  <h1>{data.title}</h1>
                </div>
                <div className="card">
                  {data.dataArray.map((card, cardIndex) => {
                    return (
                      <div
                        key={card.logoText}
                        className={
                          parseInt(index) > 1
                            ? `cards${
                                otherSelected[index][cardIndex] === true
                                  ? "active"
                                  : ""
                              }`
                            : index === 0
                            ? `cards${
                                appSelected[cardIndex] === true ? "active" : ""
                              }`
                            : `cards${
                                uiSelected[cardIndex] === true ? "active" : ""
                              }`
                        }
                        onClick={() =>
                          handleCardSelect(card.logoText, index, cardIndex)
                        }
                      >
                        <div className="cards-head">
                          <div className="left-content">
                            <img
                              src={
                                (parseInt(index) > 1 &&
                                  otherSelected[index][cardIndex] === true) ||
                                (index === 0 &&
                                  appSelected[cardIndex] === true) ||
                                (index === 1 && uiSelected[cardIndex] === true)
                                  ? card.imageSrc1
                                  : card.imageSrc
                              }
                              alt="card image"
                            />
                            <p>{card.logoText}</p>
                          </div>
                          {(parseInt(index) > 1 &&
                            otherSelected[index][cardIndex] === true) ||
                          (index === 0 && appSelected[cardIndex] === true) ||
                          (index === 1 && uiSelected[cardIndex] === true) ? (
                            <img
                              className="checked-logo"
                              src={imageData.selected}
                              alt="tick"
                            />
                          ) : null}
                        </div>
                        <div>
                          <p>{card.description1}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
        <EstimateCard appdataState={appdataState} />
      </div>
      <Footer />
    </>
  );
};

export default RecCard;
